import Config from 'react-native-config';

export const isProdEnvironment = () => {
  const currentEnv = Config.ENV || 'development';
  return currentEnv === 'production';
};
